enum SubSystem {
  General = 0, // eslint-disable-line no-unused-vars
  CompanyProfile = 1, // eslint-disable-line no-unused-vars
  Onboarding = 2, // eslint-disable-line no-unused-vars
  UserManagement = 3, // eslint-disable-line no-unused-vars
  Messaging = 4, // eslint-disable-line no-unused-vars
  eRFx = 5, // eslint-disable-line no-unused-vars
  Billing = 6, // eslint-disable-line no-unused-vars
  Compliance = 7, // eslint-disable-line no-unused-vars
  Contracting = 8, // eslint-disable-line no-unused-vars
  ERP = 9, // eslint-disable-line no-unused-vars
}

export const subSystemToString = (value: SubSystem) => {
  switch (value) {
    case SubSystem.General:
      return "General";
    case SubSystem.CompanyProfile:
      return "Company Profile";
    case SubSystem.Onboarding:
      return "Onboarding";
    case SubSystem.UserManagement:
      return "User Management";
    case SubSystem.Messaging:
      return "Messaging";
    case SubSystem.eRFx:
      return "eRFx";
    case SubSystem.Billing:
      return "Billing";
    case SubSystem.Compliance:
      return "Compliance";
    case SubSystem.Contracting:
      return "Contracting";
    case SubSystem.ERP:
      return "ERP Integration";
    default:
      return "";
  }
};

export default SubSystem;
